import styled from "styled-components";
import { COLORS } from "~/src/styles/config.style";

export const ModalTable = styled.table<{ color?: string }>`
  width: 100%;

  border: 1px solid ${({ color }) => (color ? color : COLORS.MAIN_ORANGE)};
  border-radius: 10px;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;

  line-height: 1.2;

  margin: 4px 0 4px 0;
  
  & > tbody > tr > td {
    padding: 10px;
    margin: 0;
    text-align: center;
  }

  & > tbody > tr > td:first-child {
    color: ${COLORS.WHITE};
    background-color: ${({ color }) => (color ? color : COLORS.MAIN_ORANGE)};
  }

  & > tbody > tr > td:first-child > a {
    color: ${COLORS.WHITE};
  }
}`;
